module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissions-picker"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.currentActivePermissions), function(permission) {
    return _c('tr', {
      key: permission.id
    }, [_c('td', [_c('div', {
      staticClass: "md-checkbox has-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission.selected),
        expression: "permission.selected"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": (_vm.instanceId + "-" + (permission.id))
      },
      domProps: {
        "checked": Array.isArray(permission.selected) ? _vm._i(permission.selected, null) > -1 : (permission.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = permission.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (permission.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (permission.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(permission, "selected", $$c)
          }
        }, function($event) {
          _vm.permissionsSelected()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.instanceId + "-" + (permission.id))
      }
    }, [_c('span', {
      staticClass: "inc"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    })])])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(permission.name) + " ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row__wrapper"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionsSearchQuery),
      expression: "permissionsSearchQuery"
    }],
    ref: "newRoleName",
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.permissionsSearchQuery.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_permissions_search"
    },
    domProps: {
      "value": (_vm.permissionsSearchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.permissionsSearchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_permissions_search"
    }
  }, [_vm._v("Search permissions")])])]), _vm._v(" "), _c('div', {
    staticClass: "half-width"
  }, [_c('pagination', {
    staticClass: "pull-left",
    attrs: {
      "passedPage": _vm.permissionsPage,
      "numPages": Math.ceil(_vm.permissions.length / 10)
    },
    on: {
      "activePageChange": _vm.changePermissionsPage
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(" Permission ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d8061be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/AdminManager/PermissionsPicker.vue
// module id = 732
// module chunks = 0